import React from 'react';
import {Col, Container, Row} from 'reactstrap';
import classNames from 'classnames';
import './OptinCta.scss';

export default function CtaOptin(props) {
  const ctaBox = classNames('cta-box cta-box-offset', props.ctaBox);
  const outerColor = classNames('cta-box-outer optin-gradient-blue px-3 px-sm-4 px-md-5 py-4 py-md-5 text-white', props.outerColor);
  return (
    <div className={ctaBox}>
      <Container>
        <Row>
          <Col className="px-0 px-sm-3">
            <div className={outerColor}>
              {props.children}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
